/**
 * @description Transforms sortable fields from the format "custom_fields.field_code" to "custom_fields_field_code"
 * for compatibility with the table's column definitions.
 * This is necessary because the table expects custom fields to be prefixed with "custom_fields_"
 * instead of "custom_fields.".
 *
 * @param sortableFields - An array of sortable field names.
 * @returns
 */
export function transformSortableFields(sortableFields: string[]) {
  return sortableFields.map((field) => {
    if (field.startsWith("custom_fields.")) {
      return transformCustomFieldNameToColumnId(field);
    }
    return field;
  });
}

/**
 * @description Transforms a custom field name from the format "custom_fields.field_code"
 *
 * @param customFieldName - The name of the custom field, e.g., "custom_fields.field_code".
 * @returns
 */
export function transformCustomFieldNameToColumnId(
  customFieldName: string,
): string {
  if (customFieldName.startsWith("custom_fields.")) {
    return customFieldName.replace("custom_fields.", "custom_fields_");
  }
  return customFieldName;
}

/**
 * @description Transforms a column ID from the format "custom_fields_field_code"
 * to "custom_fields.field_code" for compatibility with the custom field data structure.
 *
 * @param columnId - The column ID, e.g., "custom_fields_field_code".
 * @returns
 */
export function transformColumnIdToCustomFieldName(columnId: string): string {
  if (columnId.startsWith("custom_fields_")) {
    return columnId.replace("custom_fields_", "custom_fields.");
  }
  return columnId;
}
